module.exports = __webpack_public_path__ + "img/link2.db4b0aa7.svg";